<div class="screen-element day-overview-component" [ngClass]='{"selected":selected}'>
	<div class="day">{{getDay()}}</div>
	<div class="bars-wrap">
		<div class="bars">
			<!--<div class="bar" *ngFor="let timeslot of timeslots" style="left:10%;width:30%;">&nbsp;</div>
			<div class="bar" *ngFor="let timeslot of timeslots" style="left:70%;width:30%;">&nbsp;</div>-->
			<div class="bar" *ngFor="let timeslot of timeslots" [ngStyle]='{left:(timeslot.getStartRelative()*100+"%"),width:(timeslot.getDurationRelative()*100+"%")}'>&nbsp;</div>
		</div>
	</div>
</div>